import React from "react";
import "../PrintAudit.style.css";
import { Typography } from "@mui/material";

const ActivityListSection = ({ ActivityData }) => {
  return (
    <div className="checkList-table-container">
      <Typography className="inter-medium-500 mb-2" variant="h6">
        Audit Activities:
      </Typography>
      <table className="checkList-table no-break">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Activity</th>
            <th>Progress Status</th>
            <th>Observations</th>
            <th>CAPA</th>
            <th>Audit Point Status</th>
          </tr>
        </thead>
        <tbody>
          {ActivityData.map((item, index) => (
            <tr key={index}>
              <td width={"6%"}>{index + 1}</td>
              <td>
                <div className="d-flex align-items-center ps-1">
                  <span>{item.name}</span>
                </div>
              </td>
              <td width={"15%"}>{item.complianceStatus}</td>
              <td width={"17%"}>{item.auditorObservation || "Not Available"}</td>
              <td width={"20%"}>{item.capa || "Not Available"}</td>
              <td width={"12%"}>{item.verificationStatus}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActivityListSection;
